export default __webpack_public_path__ + "static/media/paypalTopBanner.34c10c09.svg";